import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-group col-10 px-4 py-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", { for: "patient-smoking-status" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Current Smoking Status")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "col-12 row g-0" }
const _hoisted_4 = { class: "col-12 col-lg-4 pe-lg-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "patient-smoking-status" }, " Smoking Status ", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Select Smoking Status", -1 /* HOISTED */)
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  class: "form-group col-12 col-lg-3 pe-lg-3"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "patient--smoking-status" }, [
  /*#__PURE__*/_createTextVNode(" Start Date "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_10 = { class: "input-group date datepickerInput" }
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_13 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_14 = {
  key: 1,
  class: "col-12 col-lg-3 pe-lg-3"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "patient-smoking-status" }, " Stop Date ", -1 /* HOISTED */)
const _hoisted_16 = { class: "input-group date datepickerInput" }
const _hoisted_17 = ["value"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_19 = { class: "form-group col-10 px-3 offset-md-1 row g-0 au-target" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h6", { for: "patient-historical-smoking-status" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Historical Smoking Status")
], -1 /* HOISTED */)
const _hoisted_21 = { class: "col-12 row g-0" }
const _hoisted_22 = { class: "col-12 col-lg-4 pe-lg-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "patient-smoking-status" }, " Smoking Status ", -1 /* HOISTED */)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Select Smoking Status", -1 /* HOISTED */)
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  key: 0,
  class: "col-12 col-lg-3 pe-lg-3"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { for: "patient-historical-smoking-status" }, [
  /*#__PURE__*/_createTextVNode(" Start Date"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_28 = { class: "input-group date datepickerInput" }
const _hoisted_29 = ["value"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_31 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_32 = {
  key: 1,
  class: "col-12 col-lg-3 pe-lg-3"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { for: "patient-historical-smoking-status" }, [
  /*#__PURE__*/_createTextVNode(" Stop Date"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_34 = { class: "input-group date datepickerInput" }
const _hoisted_35 = ["value"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_37 = {
  key: 0,
  class: "field-invalid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Health History",
    "full-height": false
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.patient.smokingStatus) = $event)),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.smokingStatusChanged(_ctx.patient.smokingStatus)))
            }, [
              _hoisted_6,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.smokingStatusEnum), ([key, value]) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: value.value
                }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_7))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelSelect, _ctx.patient.smokingStatus]
            ])
          ]),
          (
                            !(
                                _ctx.patient.smokingStatus === 0 ||
                                _ctx.patient.smokingStatus === _ctx.smokingStatusEnum.enum.NeverSmoker ||
                                _ctx.patient.smokingStatus === _ctx.smokingStatusEnum.enum.UnknownIfEverSmoked
                            )
                        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_DatePicker, { getDate: _ctx.smokingDateChanged }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("input", {
                        name: "smokingStartDate",
                        id: "Smoking_Start_Date",
                        type: "text",
                        class: _normalizeClass(["form-control", `${!_ctx.v$.patient.smokingStartDate.$error ? '' : 'field-invalid'}`]),
                        placeholder: "MM/DD/YYYY",
                        value: _ctx.formatDateInput(_ctx.patient.smokingStartDate),
                        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args))),
                        autocomplete: "off",
                        onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.patient.smokingStartDate.$touch && _ctx.v$.patient.smokingStartDate.$touch(...args)))
                      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_11),
                      _hoisted_12,
                      (_ctx.v$.patient.smokingStartDate.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Smoking Start Date is required."))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["getDate"])
              ]))
            : _createCommentVNode("v-if", true),
          (
                            !(
                                _ctx.patient.smokingStatus === 0 ||
                                _ctx.patient.smokingStatus === _ctx.smokingStatusEnum.enum.NeverSmoker ||
                                _ctx.patient.smokingStatus === _ctx.smokingStatusEnum.enum.UnknownIfEverSmoked
                            )
                        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_DatePicker, { getDate: _ctx.smokingDateChanged }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("input", {
                        name: "smokingEndDate",
                        id: "Smoking_End_Date",
                        type: "text",
                        class: "form-control",
                        placeholder: "MM/DD/YYYY",
                        value: _ctx.formatDateInput(_ctx.patient.smokingEndDate),
                        onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args))),
                        autocomplete: "off"
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_17),
                      _hoisted_18
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["getDate"])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    content_2: _withCtx(() => [
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.patient.historicalSmokingStatus) = $event)),
              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.historicalSmokingStatusChanged(_ctx.patient.historicalSmokingStatus)))
            }, [
              _hoisted_24,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.smokingStatusEnum), ([key, value]) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: value.value
                }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_25))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelSelect, _ctx.patient.historicalSmokingStatus]
            ])
          ]),
          (
                            !(
                                _ctx.patient.historicalSmokingStatus === 0 ||
                                _ctx.patient.historicalSmokingStatus === _ctx.smokingStatusEnum.enum.NeverSmoker ||
                                _ctx.patient.historicalSmokingStatus === _ctx.smokingStatusEnum.enum.UnknownIfEverSmoked
                            )
                        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _hoisted_27,
                _createVNode(_component_DatePicker, { getDate: _ctx.smokingDateChanged }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("input", {
                        name: "historicalSmokingStartDate",
                        id: "Historical_Smoking_Start_Date",
                        type: "text",
                        class: _normalizeClass(["form-control", `${!_ctx.v$.patient.historicalSmokingStartDate.$error ? '' : 'field-invalid'}`]),
                        placeholder: "MM/DD/YYYY",
                        value: _ctx.formatDateInput(_ctx.patient.historicalSmokingStartDate),
                        onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args))),
                        autocomplete: "off",
                        onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.v$.patient.historicalSmokingStartDate.$touch && _ctx.v$.patient.historicalSmokingStartDate.$touch(...args)))
                      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_29),
                      _hoisted_30,
                      (_ctx.v$.patient.historicalSmokingStartDate.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Historical Smoking Start Date is required."))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["getDate"])
              ]))
            : _createCommentVNode("v-if", true),
          (
                            !(
                                _ctx.patient.historicalSmokingStatus === 0 ||
                                _ctx.patient.historicalSmokingStatus === _ctx.smokingStatusEnum.enum.NeverSmoker ||
                                _ctx.patient.historicalSmokingStatus === _ctx.smokingStatusEnum.enum.UnknownIfEverSmoked
                            )
                        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _hoisted_33,
                _createVNode(_component_DatePicker, { getDate: _ctx.smokingDateChanged }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("input", {
                        name: "historicalSmokingEndDate",
                        id: "Historical_Smoking_End_Date",
                        type: "text",
                        class: _normalizeClass(["form-control", `${!_ctx.v$.patient.historicalSmokingEndDate.$error ? '' : 'field-invalid'}`]),
                        placeholder: "MM/DD/YYYY",
                        value: _ctx.formatDateInput(_ctx.patient.historicalSmokingEndDate),
                        onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args))),
                        autocomplete: "off",
                        onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.v$.patient.historicalSmokingEndDate.$touch && _ctx.v$.patient.historicalSmokingEndDate.$touch(...args)))
                      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_35),
                      _hoisted_36,
                      (_ctx.v$.patient.historicalSmokingEndDate.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Historical Smoking End Date is required."))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["getDate"])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}